<ion-grid [fixed]="true" class="payment-selection-grid">
  <ion-row>
    <ion-col size="12" size-lg="8" offset-lg="2">
      <ion-card class="office-info-card">
        <ion-card-header>
          <ion-card-title>
            <ion-icon name="business-outline" class="office-icon"></ion-icon>
            <span class="office-title">{{ "PAYMENT.OFFICE.TITLE" | translate }}</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <div class="office-details">
            <div class="office-name">{{ selectedOffice()!.name | localized }}</div>
            <div class="office-address" (click)="openGoogleMaps()">
              <ion-icon name="location-outline"></ion-icon>
              {{ selectedOffice()!.address | localized }}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12" size-lg="8" offset-lg="2">
      <ion-card class="comment-card">
        <ion-card-header>
          <ion-card-title>
            <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            <span>{{ "PAYMENT.COMMENT" | translate }}</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-textarea
            mode="md"
            class="comment-text"
            label="{{ 'PAYMENT.COMMENT.OPTIONAL' | translate }}"
            labelPlacement="floating"
            fill="outline"
            [counter]="true"
            [autoGrow]="true"
            [(ngModel)]="comment"
            maxlength="500">
          </ion-textarea>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12" size-lg="8" offset-lg="2">
      <!-- @if(!hasMobilePhoneProvided()) {
      <app-warning-message [url]="'profile'" [message]="'PAYMENT.ERROR.MOBILE_PHONE_NOT_PROVIDED' | translate"></app-warning-message>
      } -->

      <div class="payment-methods-section">
        <div class="payment-methods-title">
          <ion-icon name="wallet-outline"></ion-icon>
          <span>{{ "PAYMENT.SELECT_PAYMENT_METHOD" | translate }}</span>
        </div>
        <div class="payment-methods-list">
          <ion-button
            color="secondary"
            class="payment-option-card payment-method"
            (click)="createOrder(paymentMethod.Card)">
            <ion-icon name="card-outline"></ion-icon>
            Credit / Debit Card
          </ion-button>

          @if(isIOS()) {
          <ion-button
            color="black"
            class="apple-pay-button payment-method"
            type="button"
            (click)="createOrder(paymentMethod.ApplePay)">
            Buy with
            <ion-icon name="logo-apple"></ion-icon>
            Pay
          </ion-button>
          } @if(isAndroid()) {
          <div id="google-pay-button-container" class="payment-method"></div>
          }
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
